import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { eiwrsDepotManagementServices } from "../../../../APIServices/EIWRS/eiwrsDepotManagementServices";
import Moment from "react-moment";
import SplitPane from "react-split-pane";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";


const DepotProperties = ({ onMouseDown, tableRef, rowData }) => {
  const [showLoader, setShowLoader] = useState(false);
  const [version, setVersion] = useState(1);
  let { studyId } = useParams();

  const getHeighestVersionDepotRowHistory = async () => {
    setShowLoader(true);
    let data =
      await eiwrsDepotManagementServices.getHeighestVersionDepotRowHistory(
        studyId,
        rowData?.depotId
      );
    setShowLoader(false);
    setVersion(data?.data || 1);
  };
  useEffect(() => {
    getHeighestVersionDepotRowHistory();
  }, [rowData, studyId]);
  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        style={{ height: "-webkit-fill-available" }}
      >
        {showLoader ? (
          <PageLoader/>
        ) : (
          <Table ref={tableRef} className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0 z-1">
              <tr>
                <th
                  onMouseDown={(e) => onMouseDown(e, 0)}
                  className="text-center"
                  style={{ width: 45 }}
                >
                  Sr.
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Attribute</th>
                <th onMouseDown={(e) => onMouseDown(e, 2)}>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-center">1.</td>
                <td>Version</td>
                <td className="text-capitalize">{version}</td>
              </tr>
              <tr>
                <td className="text-center">2.</td>
                <td>Updated By</td>
                <td className="text-capitalize">{rowData?.updatedBy}</td>
              </tr>
              <tr>
                <td className="text-center">3.</td>
                <td>Updated Date | Time</td>
                <td className="text-capitalize">
                  <Moment format="DD MMM YYYY | HH:mm" withTitle>
                    {rowData?.updatedAt}
                  </Moment>
                </td>
              </tr>
            </tbody>
          </Table>
        )}
      </SplitPane>
    </>
  );
};

export default DepotProperties;
